"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.easeInCubic = easeInCubic;
exports.easeOutSine = easeOutSine;
function easeInCubic(t, b, c, d) {
  return c * (t /= d) * t * t + b;
}
function easeOutSine(t, b, c, d) {
  return c * Math.sin(t / d * (Math.PI / 2)) + b;
}
//# sourceMappingURL=Easings.js.map